import { AppEventEnum } from "model/enums/enum-app-event";
import { useCallback } from "react";
import { useEventTools } from "./events/event-tools";
import { EntradaListSearchProps } from "views/pages/private/entrada/components/entrada-list/entrada-list-search-props";
import { ManifestosSearchProps } from "views/pages/private/manifestos/components/manifestos-list/manifestos-search-props";
import { CategoriaListSearchProps } from "views/pages/private/cadastros/categoria/components/categoria-list/categoria-list-search-props";
import { NcmListSearchProps } from "views/pages/private/cadastros/ncm/components/ncm-list/ncm-list-search-props";
import { ImpostoListSearchProps } from "views/pages/private/cadastros/impostos/components/imposto-list/imposto-list-search-props";
import { PontosVendaListSearchProps } from "views/pages/private/pontos-venda/components/pontos-venda-list/pontos-venda-list-search-props";
import { HistoricoVendaListSearchProps } from "views/pages/private/historico-vendas/components/historico-venda-tabs/components/historico-venda-list-search-props";
import { PessoaListSearchProps } from "views/pages/private/cadastros/pessoa/components/pessoa-list/pessoa-list-search-props";
import { DocumentoFiscalListSearchProps } from "views/pages/private/fiscal/documento-fiscal/components/documento-fiscal-list/documento-fiscal-list-search-props";
import { ComissaoListSearchProps } from 'views/pages/private/cadastros/comissao/components/comissao-list/comissao-list-search-props';
import { ProdutoListSearchProps } from "views/pages/private/cadastros/produto/components/produto-list/produto-list-search-props";
import { ConvenioListSearchProps } from "views/pages/private/cadastros/convenio/components/convenio-list/convenio-list-search-props";
import { ProdutoSelecionarBuscaProps } from "views/components/modals/produto-selecionar-modal/components/produto-selecionar-busca-props";
import { PromocaoListSearchProps } from "views/pages/private/cadastros/promocao/components/promocao-list/promocao-list-search-props";
import { RelatoriosAvancadosListSearchProps } from 'views/pages/private/relatorios/relatorios-avancados/components/relatorios-avancados-list/relatorios-avancados-list-search-props';
import { PessoaSelecionarBuscaProps } from "views/components/modals/pessoa-selecionar-modal/components/pessoa-selecionar-busca-props";


export const useFiltrosModais = () => {

    const { callEvent } = useEventTools()

    //----------------------------------------------------------------------------------------------------------------EntradaFiltro
    const abrirEntradaFiltroModal = useCallback(
        (filtros: EntradaListSearchProps) => {
            callEvent(AppEventEnum.EntradaFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharEntradaFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.EntradaFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    //-------------------------------------------------------------------------------------------------------ManifestosFiltro

    const abrirManifestosFiltroModal = useCallback(
        (filtros: ManifestosSearchProps) => {
            callEvent(AppEventEnum.ManifestosFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharManifestosFiltrosModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.ManifestosFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);
    ///-------------------------------------------------------------------------------------------------------------CategoriaFiltro

    const abrirCategoriaFiltroModal = useCallback(
        (filtros: CategoriaListSearchProps) => {
            callEvent(AppEventEnum.CategoriaFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharCategoriaFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.CategoriaFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------NcmsFiltro

    const abrirNcmsFiltroModal = useCallback(
        (filtros: NcmListSearchProps) => {
            callEvent(AppEventEnum.NcmsFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharNcmsFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.NcmsFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ImpostosFiltro

    const abrirImpostosFiltroModal = useCallback(
        (filtros: ImpostoListSearchProps) => {
            callEvent(AppEventEnum.ImpostosFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharImpostosFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.ImpostosFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------PDVFiltro

    const abrirPDVFiltroModal = useCallback(
        (filtros: PontosVendaListSearchProps) => {
            callEvent(AppEventEnum.PDVFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharPDVFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.PDVFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------HistoricoVendaFiltros

    const abrirHistoricoVendaFiltroModal = useCallback(
        (filtros: HistoricoVendaListSearchProps) => {
            callEvent(AppEventEnum.HistoricoVendaFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharHistoricoVendaFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.HistoricoVendaFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ProdutoFiltros
    type setFiltrosProdutosType = (filtos: ProdutoListSearchProps) => void;

    const abrirProdutoFiltroModal = useCallback(
        (filtros: ProdutoListSearchProps, callback?: setFiltrosProdutosType) => {
            callEvent(AppEventEnum.ProdutoFiltroModal, {
                openned: true,
                filtros,
                callback
            });
        },
        [callEvent]
    );

    const fecharProdutoFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.ProdutoFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ProdutoFiltros
    type setFiltrosType = (filtos: PessoaListSearchProps) => void;

    const abrirPessoasFiltroModal = useCallback(
        (filtros: PessoaListSearchProps, callback?: setFiltrosType, esconder?: {
            tpCadastro?: boolean
            status?: boolean
        }) => {
            callEvent(AppEventEnum.PessoasFiltroModal, {
                openned: true,
                filtros,
                esconder,
                callback
            });
        },
        [callEvent]
    );

    const fecharPessoasFiltroModal = useCallback((
        att: boolean = false, filtros?: PessoaListSearchProps
    ) => {
        callEvent(AppEventEnum.PessoasFiltroModal, {
            openned: false,
            att,
            filtros
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ProdutoFiltros

    const abrirDocumentoFiscalFiltroModal = useCallback(
        (filtros: DocumentoFiscalListSearchProps) => {
            callEvent(AppEventEnum.DocumentoFiscalFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharDocumentoFiscalFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.DocumentoFiscalFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ConvenioFiltros

    const abrirConvenioFiltroModal = useCallback(
        (filtros: ConvenioListSearchProps) => {
            callEvent(AppEventEnum.ConvenioFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharConvenioFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.ConvenioFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ComissaoFiltros

    const abrirComissoesFiltroModal = useCallback(
        (filtros: ComissaoListSearchProps) => {
            callEvent(AppEventEnum.ComissaoFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharComissoesFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.ComissaoFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------PromocaoFiltros
    const abrirPromocoesFiltroModal = useCallback(
        (filtros: PromocaoListSearchProps) => {
            callEvent(AppEventEnum.PromocaoFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharPromocoesFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.PromocaoFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ProdutoSelecionar
    const abrirProdutoSelecionarModal = useCallback(
        (props: ProdutoSelecionarBuscaProps) => {
            callEvent(AppEventEnum.ProdutoSelecionarModal, { ...props, openned: true });
        },
        [callEvent]
    );

    const fecharProdutoSelecionarModal = useCallback(() => {
        callEvent(AppEventEnum.ProdutoSelecionarModal, {
            openned: false,
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------RelaótiosAvancadosFiltro
    const abrirRelatoriosAvancadosFiltroModal = useCallback(
        (filtros: RelatoriosAvancadosListSearchProps) => {
            callEvent(AppEventEnum.RelatoriosAvancadosFiltroModal, {
                openned: true,
                filtros,
            });
        },
        [callEvent]
    );

    const fecharRelatoriosAvancadosFiltroModal = useCallback((
        att: boolean = false
    ) => {
        callEvent(AppEventEnum.RelatoriosAvancadosFiltroModal, {
            openned: false,
            att
        });
    }, [callEvent]);

    ///-------------------------------------------------------------------------------------------------------------ProdutoSelecionar
    const abrirPessoaSelecionarModal = useCallback(
        (props: PessoaSelecionarBuscaProps) => {
            callEvent(AppEventEnum.PessoaSelecionarModal, {
                ...props,
                openned: true
            });
        },
        [callEvent]
    );

    const fecharPessoaSelecionarModal = useCallback(() => {
        callEvent(AppEventEnum.PessoaSelecionarModal, {
            openned: false,
        });
    }, [callEvent]);

    return {
        abrirEntradaFiltroModal,
        fecharEntradaFiltroModal,

        abrirManifestosFiltroModal,
        fecharManifestosFiltrosModal,

        abrirCategoriaFiltroModal,
        fecharCategoriaFiltroModal,

        abrirNcmsFiltroModal,
        fecharNcmsFiltroModal,

        abrirImpostosFiltroModal,
        fecharImpostosFiltroModal,

        abrirPDVFiltroModal,
        fecharPDVFiltroModal,

        abrirHistoricoVendaFiltroModal,
        fecharHistoricoVendaFiltroModal,

        abrirProdutoFiltroModal,
        fecharProdutoFiltroModal,

        abrirPessoasFiltroModal,
        fecharPessoasFiltroModal,

        abrirDocumentoFiscalFiltroModal,
        fecharDocumentoFiscalFiltroModal,

        abrirConvenioFiltroModal,
        fecharConvenioFiltroModal,

        abrirComissoesFiltroModal,
        fecharComissoesFiltroModal,

        abrirPromocoesFiltroModal,
        fecharPromocoesFiltroModal,

        abrirProdutoSelecionarModal,
        fecharProdutoSelecionarModal,

        abrirRelatoriosAvancadosFiltroModal,
        fecharRelatoriosAvancadosFiltroModal,

        abrirPessoaSelecionarModal,
        fecharPessoaSelecionarModal,
    }
}